import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import connectApi from 'api/connectApi'
import axios from 'axios'
import { constants, sendMessageToWorker } from 'helpers'
import { DepositSliceNames, DepositStateType, DepositType } from 'storeTypes'

export const veDepositsAction = createAsyncThunk<
    { veDeposit: DepositType; veCode: string },
    { veCode: string },
    { rejectValue: string }
>(
    DepositSliceNames.veDepositsAction,
    async ({ veCode }: { veCode: string }, { rejectWithValue }) => {
        const { VE_DEPOSIT } = constants.endpoints
        try {
            const { data } = await connectApi.get(`${VE_DEPOSIT}${veCode}/`)

            sendMessageToWorker({
                [constants.MESSAGES.STORE_VE_DEPOSIT]: {
                    veDeposit: data,
                    veCode
                }
            })

            return {
                veDeposit: data,
                veCode
            }
        } catch (error: unknown) {
            const errorMessage = axios.isAxiosError(error)
                ? error.message
                : 'Failed to fetch ve deposits'
            return rejectWithValue(errorMessage)
        }
    }
)

const initialState: DepositStateType = {}

export const veDepositSlice = createSlice({
    name: DepositSliceNames.veAllDeposits,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(veDepositsAction.pending, (state, action) => {
            const veCode = action.meta.arg.veCode ?? ''
            state[veCode ?? ''] = {
                veDepositData: undefined,
                loading: true,
                error: ''
            }
        })
        builder.addCase(veDepositsAction.fulfilled, (state, action) => {
            const veCode = action.meta.arg.veCode ?? ''
            state[veCode ?? ''] = {
                veDepositData: action.payload.veDeposit,
                loading: false,
                error: ''
            }
        })
        builder.addCase(veDepositsAction.rejected, (state, action) => {
            const veCode = action.meta.arg.veCode ?? ''
            state[veCode ?? ''] = {
                veDepositData: undefined,
                loading: false,
                error: action.payload || ''
            }
        })
    }
})

export default veDepositSlice.reducer
